import { buttonStyles } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import {
  Icon,
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@festina-life/ui/structure'
import cx from 'classnames'

import { TabLimitSettings } from './TabLimitSettings'

type Props = {
  onCloseAll: () => void
  onCloseInactive: () => void
}

export const NavigationTabsOptions = ({
  onCloseAll,
  onCloseInactive,
}: Props) => {
  const translate = useTranslate()
  const buttonClassName = cx(
    buttonStyles({
      variant: 'discreet',
      disabled: false,
      isFullWidth: false,
      isDanger: false,
    }),
    'px-0! justify-start',
  )

  return (
    <Popover className="relative mt-1">
      <PopoverButton>
        <Icon name="EllipsisVertical" size="md" />
      </PopoverButton>
      <PopoverPanel
        isShowingBackdrop
        className={cx(
          'absolute right-2 z-10 flex flex-col rounded-md p-2 shadow-lg',
          paperStyles({ isFaded: true, borders: ['all'] }),
        )}
      >
        <PopoverButton className={buttonClassName} onClick={onCloseAll}>
          {translate('navigationTab.closeAll')}
        </PopoverButton>
        <PopoverButton className={buttonClassName} onClick={onCloseInactive}>
          {translate('navigationTab.closeInactive')}
        </PopoverButton>
        <TabLimitSettings />
      </PopoverPanel>
    </Popover>
  )
}
